const timeFormat = 'hh:mm a';

export default timeFormat;



// WEBPACK FOOTER //
// ./src/config/timeFormat.js